<template>
  <div class="table-page-wrapper">

    <div v-show="searchStatus" class="search-wrapper">
      <date-format-select @changeDateFormatData="changeDateFormatData($event.dateFormatId)"/>
      <search-dsp-select v-model="tableParams.dspId" dsp-type="2"/>
      <search-dsp-apply-select v-model="tableParams.dspSlotId" :dsp-id="tableParams.dspId" />
      <search-channel-select v-model="tableParams.channelId" channel-type="2"/>
      <search-channel-slot-select v-model="tableParams.slotId" :channel-id="tableParams.channelId" />
      <el-input v-model="tableParams.appBundle" clearable  placeholder="应用名称或包名" />
      <base-date-picker @changeDate="changeDate" style="margin-right: 15px;" />
      <el-button @click="toQuery" type="primary" >搜索</el-button>
    </div>

    <div class="table-wrapper">
      <table-column
        @search="searchColumn"
        @refresh="toQuery"
        @change="changeColumn"
        :column="columns"
        style="padding-bottom: 10px;">
        <el-button @click="downExcel('/report/cpdApp/download', 'CPD应用报表', tableParams)" type="warning" size="small">下载</el-button>
      </table-column>

      <el-table
        v-loading="tableLoading"
        :data="tableData"
        @sort-change="sortChange"
        height="80vh"
        :header-cell-style="{background:'#fafafa'}"
        :summary-method="tableSummary"
        show-summary
        highlight-current-row
        size="small"
        ref="report"
        class="js-table"
        style="width: 100%">
          <el-table-column v-if="tableParams.isDay === 1 || tableParams.isHour === 1" prop="reportTime" :label="tableParams.isDay === 1 ? '日期' : '时间'" fixed sortable align="center" />
          <el-table-column
            v-for="(v, i) in checkColumns"
            :prop="v.field"
            :label="v.title"
            :width="v.width"
            :min-width="v.minWidth"
            :sortable="v.field === 'slotId'
            || v.field === 'uniShowSmt'
            || v.field === 'uniAdsSmt'
            || v.field === 'uniAdeSmt'
            || v.field === 'uniAieSmt'
            || v.field === 'knotPrice'
            || v.field === 'realBidPrice'
            || v.field === 'basePrice'
            || v.field === 'receivePrice'"
            :key="i"
            align="center">
            <template v-slot="scope">
              <el-tag v-if="v.field === 'clickRate' || v.field === 'fillingRate' || v.field === 'bidRate' || v.field === 'showRat'" type="info">{{ scope.row[v.field] }}%</el-tag>
              <span v-else>{{ scope.row[v.field] }}</span>
            </template>
          </el-table-column>
      </el-table>

      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :total="pagination.total"
        :pager-count="6"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :page-sizes="[10, 30, 60]"
        background
        layout="total,sizes,prev,pager,next"
        style="margin-top: 40px;" />
    </div>
  </div>
</template>

<script>
import DateFormatSelect from "@/components/DateFormatSelect";
import SearchDspSelect from '@/components/SearchDspSelect'
import SearchDspApplySelect from '@/components/SearchDspApplySelect'
import SearchChannelSelect from '@/components/SearchChannelSelect'
import SearchChannelSlotSelect from '@/components/SearchChannelSlotSelect'
import TableColumn from '@/components/TableColumn'
import initTableMixin from '@/mixins/initTable'
import downExcelMixin from '@/mixins/downExcel'

import BaseDatePicker from '@/components/BaseDatePicker'

export default {
  name: 'Manage/cpdApply',
  components: {
    SearchDspSelect,
    SearchChannelSelect,
    SearchChannelSlotSelect,
    BaseDatePicker,
    TableColumn,
    SearchDspApplySelect,
    DateFormatSelect
  },
  mixins: [initTableMixin, downExcelMixin],
  data () {
    return {
      searchDate: undefined,
      columns: [
        { field: 'channelName', title: '渠道名称' },
        { field: 'slotId', title: '渠道广告位ID' },
        { field: 'slotName', title: '渠道广告位名称' },
        { field: 'dspName', title: 'DSP名称' },
        { field: 'dspSlotName', title: 'DSP广告位名称' },
        { field: 'appName', title: '应用名称' },
        { field: 'appBundle', title: '应用包名' },
        { field: 'uniShowSmt', title: '展示次数' },
        { field: 'uniAdsSmt', title: '下载开始次数' },
        { field: 'uniAdeSmt', title: '下载完成次数'},
        { field: 'uniAieSmt', title: '安装次数' },
        { field: 'receivePrice', title: '收入单价' },
        { field: 'basePrice', title: '收入' },
        { field: 'realBidPrice', title: '支出' },
        { field: 'knotPrice', title: '结算单价' },
      ],
      dateFormatId:undefined,
    }
  },
  created () {
  },
  mounted () {
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    beforeInit () {
      this.tableUrl = '/report/cpdApp/list'
      return true
    },
    afterInit (res) {
      this.tableData = res.data.records
    },
    changeDate (date) {
      this.tableParams.start = date.startTime
      this.tableParams.finish = date.endTime
    },
    changeDateFormatData (dateFormatId) {
      this.dateFormatId=dateFormatId
      if (dateFormatId === 0) {
        this.tableParams.isDay = 2
        this.tableParams.isHour = 2
      } else if (dateFormatId === 1) {
        this.tableParams.isDay = 1
        this.tableParams.isHour = null
      } else if (dateFormatId === 2) {
        this.tableParams.isDay = null
        this.tableParams.isHour = 1
      }
      this.tableParams.asc = ''
      this.tableParams.desc = ''
    },
    tableSummary (row) {
      const arr = ['uniShowSmt', 'uniAdsSmt', 'uniAdeSmt', 'uniAieSmt', 'realBidPrice', 'basePrice']
      const fixedArr = ['realBidPrice', 'basePrice']
      const { data } = row
      let checklists=this.checkColumns.map(item=>{
        return item.field
      })
      if(this.tableParams.isTime!==0){
        checklists.unshift('isTime')
      }
      const out = []
      for (let i = 0; i < checklists.length; i++) {
        if (i === 0) {
          out[i] = '合计'
        } else {
          if (fixedArr.indexOf(checklists[i]) > -1) {
            out[i] = arr.indexOf(checklists[i]) > -1 ? (data.reduce((total, item) => { return total + Number(item[checklists[i]]) }, 0)).toFixed(2) : '-'
          } else {
            out[i] = arr.indexOf(checklists[i]) > -1 ? data.reduce((total, item) => { return total + Number(item[checklists[i]]) }, 0) : '-'
          }
        }
      }
      return out
    },
    toQuery () {
      this.pagination.pageNum = 1
      if (!this.isTime && (this.tableParams.asc === 'timeHour' || this.tableParams.desc === 'timeHour')) {
        this.tableParams.asc = ''
        this.tableParams.desc = ''
      }
      this.init()
    },
    sortChange (column) {
      this.tableParams.asc = ''
      this.tableParams.desc = ''
      if (column.order === 'ascending') {
        this.tableParams.asc = column.prop
      } else {
        this.tableParams.desc = column.prop
      }
      this.init()
    }
  }
}
</script>

<style scoped lang="scss">
.search-wrapper{
  padding: 15px 15px 5px;
  margin-bottom: 10px;
  background: #ffffff;
  &>*{
    margin-right: 15px;
    margin-bottom: 10px;
    &:last-child{
      margin-right: 0;
    }
  }

  &>.el-select,&>.el-input{
    width: 220px;
  }
}

.table-wrapper{
  padding: 15px;
  background: #ffffff;
  .table__operation{
    padding-bottom: 10px;
  }
}

// .el-table::before {
//   height: 0;
// }

.el-pagination {
  text-align: right;
}
</style>
